import React from 'react';
import { Text, View, StyleSheet, Dimensions } from 'react-native';
import Animated, { useSharedValue, useAnimatedStyle, withTiming, interpolateColor, runOnJS, withDelay } from 'react-native-reanimated';
import { Gesture, GestureDetector } from 'react-native-gesture-handler';
// import { SIcon, SText, SView } from 'servisofts-component2';


const PopupDinamic = ({
    height = 500,
    maxHeight = 550,
    color = "#89C608",
    label = "",
    zIndex = 1,
    children = <></>,
    onPress = () => { }
}) => {

    const translate = useSharedValue(0);
    const heightAnim = useSharedValue(height);

    const gesture = Gesture.Pan()
        .onUpdate((event) => {
            const newHeight = heightAnim.value - event.translationY;
            if (newHeight >= height - 50 && newHeight <= maxHeight + 50) {
                translate.value = event.translationY;
            }
        })
        .onEnd(() => {
            const finalHeight = heightAnim.value - translate.value;
            heightAnim.value = finalHeight;
            translate.value = 0;

            // Decide the target height based on the threshold
            const targetHeight = finalHeight >= maxHeight * 0.90 ? maxHeight : height;

            // Animate to the target height
            heightAnim.value = withTiming(targetHeight, { duration: 250 });

        });

    const animatedStyle = useAnimatedStyle(() => ({
        height: heightAnim.value - translate.value
    }));



    return (
        <Animated.View style={[styles.container, animatedStyle]}>
            <GestureDetector gesture={gesture}>
                <Animated.View style={[styles.slider]} >
                    {children}
                </Animated.View>
            </GestureDetector>

        </Animated.View>
    );
};

const styles = StyleSheet.create({
    container: {
        zIndex: 2,
        position: "absolute",
        bottom: 0,
        maxWidth: 400,
        width: "100%",
        alignItems: 'center',
        justifyContent: 'center',
    },
    slider: {
        top: 0,
        width: "100%",
        height: "100%",

    },
});

export default PopupDinamic;
